export const meta = {
  alias: 'age-verification',
  name: 'Age Verification',
  prefix: 'eapp-age-verification'
};
